import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Breadcrumb from '../components/breadcrumb'
import SectorPage from '../components/sectorPage'

const SupermarketPage = ({location}) => {
  return (
    <Layout simpleHeader={true} url="/grande-distribution" type="sector">
      <SEO 
        title="Classement des meilleurs sites de la grande distribution"
        description="Quels sont les meilleurs sites de la grande distribution de l'Observatoire de l'impact positif ? Points forts et les points faibles des sites de drive français."
        path="/grande-distribution" />
      
      <Breadcrumb url="/grande-distribution" label="Grande distribution" /> 

      <SectorPage slug="supermarket" type="sector" />
    </Layout>
  )
  }

export default SupermarketPage

